export default [
    {
        path: 'livro-psicotropico',
        component: () => import(
            /* webpackChunkName: 'farmacia-livro-psicotropico' */
            '@/views/farmacia/livro-psicotropico/Index'
        ),
        redirect: 'livro-psicotropico/index',
        children: [
            {
                name: 'farmacia-livro-psicotropico-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-livro-psicotropico' */
                    '@/views/farmacia/livro-psicotropico/List.vue'
                ),
            },
            {
                name: 'farmacia-livro-psicotropico-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'farmacia-livro-psicotropico' */
                    '@/views/farmacia/livro-psicotropico/Form.vue'
                ),
            },
            {
                name: 'farmacia-livro-psicotropico-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'farmacia-livro-psicotropico' */
                    '@/views/farmacia/livro-psicotropico/Form.vue'
                ),
            },
        ],
    },
]